export default __webpack_public_path__ + "static/media/xtm.fca50f67.svg";